import React from 'react';

import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route, Link } from 'react-router';

import MobileHeader from '../components/MobileHeader/MobileHeader';
import TouchLink from '../components/TouchLink';

import ChapterItem from '../components/ChapterItem/ChapterItem';

const ChapterList = React.createClass({
	mixins: [ReactFireMixin],

	getInitialState: function () {
		return {
			book: null,
			chapters: null
		};
	},

	componentWillMount: function () {
		this.bindAsObject(firebaseRoot.child('content/books').child(this.props.params.bookId), "book");
		this.bindAsArray(firebaseRoot.child('content/chapters').child(this.props.params.bookId), "chapters");
	},

	render() {

		return(
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='default'
					title='Get tutored'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<ol className="chapters-list">
						{
							this.state.chapters.map(chapter => (
								<ChapterItem
									element="li"
									label={chapter.name}
									key={chapter['.key']}
									to={`/book/${this.state.book['.key']}/${chapter['.key']}`}
									icon={chapter.icon}
								/>
							))
						}
					</ol>
				</div>
			</div>
		);
	}
});

export default ChapterList;



/** WEBPACK FOOTER **
 ** ./src/screens/ChapterList.js
 **/